import { useTranslation } from "react-i18next";

export const CoachBillingReport = ({ report, isCurrentMonth, plan }) => {
  const { t } = useTranslation("dashboard");
  const { athletes = [], reportedAmount } = report;
  const { amount: planAmount } = plan;
  return (
    <>
      <section role="table-wrapper" data-borders-inside data-scrollable>
        <table role="report-table">
          <thead className="labels">
            <tr>
              <th className="name">{t("coachBillingReport.athlete")}</th>
              <th className="email">{t("coachBillingReport.email")}</th>
              <th className="amount">
                {t("coachBillingReport.totalDays")}
              </th>
            </tr>
          </thead>
          <tbody>
            {athletes.length > 0 &&
              athletes.map((athlete) => {
                const {
                  athleteName,
                  athleteEmail,
                  amount: athleteAmount,
                  athleteId,
                } = athlete;
                return (
                  <tr className="report" key={String(athleteId)}>
                    <td className="name">{athleteName}</td>
                    <td className="email">{athleteEmail}</td>
                    <td className="amount">
                      {Number(athleteAmount).toFixed(0)}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </section>

      <div className="total">
        <div className="totalValue">
          {isCurrentMonth && (
            <span>{t("coachBillingReport.estimated")} </span>
          )}
          {t("coachBillingReport.total")}:{" "}
          <span className="clipped font-semibold">
            ${Number((reportedAmount * planAmount) / 100).toFixed(2)}
          </span>
        </div>
      </div>
    </>
  );
};
